import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import dynamic from 'next/dynamic'
import type {FC} from 'react'
import {Container} from 'src/common/Container'

const RelatedArticlesCarousel = dynamic(
  () => import('./components/RelatedArticlesCarousel').then((mod) => mod.RelatedArticlesCarousel),
  {ssr: true},
)

/**
 * Props for `RelatedArticlesGrid`.
 */
export type RelatedArticlesGridProps = SliceComponentProps<Content.RelatedArticlesGridSlice>

/**
 * Component for "RelatedArticlesGrid" Slices.
 */
const RelatedArticlesGrid: FC<RelatedArticlesGridProps> = ({slice}) => {
  const articles = slice.primary.articles
    .map((item) => item.article)
    .filter((article) => isFilled.contentRelationship(article))

  if (articles.length === 0) {
    return null
  }

  return (
    <Container
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      backgroundColor="Grey/100"
      className="flex-col gap-6 !py-10"
    >
      <div className="mx-auto flex w-full max-w-[1200px] px-5 md:px-10 lg:px-5 xl:px-0">
        {isFilled.keyText(slice.primary.heading) && (
          <h2 className="text-24 font-medium leading-normal max-md:tracking-[-.24px] md:leading-10">
            {slice.primary.heading}
          </h2>
        )}
      </div>

      <RelatedArticlesCarousel articles={articles} />
    </Container>
  )
}

export default RelatedArticlesGrid
